'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _genericRowItem = require('../generic-row-item');

var _genericRowItem2 = _interopRequireDefault(_genericRowItem);

var _backdrop = require('../../backdrop');

var _backdrop2 = _interopRequireDefault(_backdrop);

var _filter = require('../../../constants/filter');

var _filter2 = _interopRequireDefault(_filter);

var _filterInitial = require('../../../constants/filter-initial');

var _filterInitial2 = _interopRequireDefault(_filterInitial);

var _filter3 = require('./filter.scss');

var _filter4 = _interopRequireDefault(_filter3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    capabilities: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
    filterValue: _propTypes2.default.string.isRequired,
    setFilterValue: _propTypes2.default.func.isRequired,
    onOpen: _propTypes2.default.func.isRequired,
    hideFilter: _propTypes2.default.func.isRequired
};

var getFilterItems = function getFilterItems(capabilities) {
    if (capabilities.length) {
        return Object.values(_filter2.default);
    }

    return Object.values(_filterInitial2.default);
};

var SearchFilter = function (_React$PureComponent) {
    _inherits(SearchFilter, _React$PureComponent);

    function SearchFilter(props) {
        _classCallCheck(this, SearchFilter);

        var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

        _this.handleClickBackdrop = _this.handleClickBackdrop.bind(_this);
        _this.toggleMenu = _this.toggleMenu.bind(_this);

        _this.state = { active: false };
        return _this;
    }

    SearchFilter.prototype.toggleMenu = function toggleMenu() {
        var active = !this.state.active;
        if (active) {
            this.props.onOpen();
        }

        this.setState({ active: active });
    };

    SearchFilter.prototype.handleClickBackdrop = function handleClickBackdrop() {
        this.setState({ active: false });
    };

    SearchFilter.prototype.render = function render() {
        var _ClassNames,
            _ClassNames2,
            _this2 = this;

        var _props = this.props,
            filterValue = _props.filterValue,
            setFilterValue = _props.setFilterValue,
            capabilities = _props.capabilities,
            hideFilter = _props.hideFilter;


        var filterClasses = (0, _classnames2.default)(_filter4.default.filter, (_ClassNames = {}, _ClassNames[_filter4.default.filterActive] = this.state.active, _ClassNames));

        var contextMenuClasses = (0, _classnames2.default)(_filter4.default.contextMenu, (_ClassNames2 = {}, _ClassNames2[_filter4.default.contextMenuActive] = this.state.active, _ClassNames2));

        var filterItems = getFilterItems(capabilities);

        return hideFilter ? _react2.default.createElement(_genericRowItem2.default, null) : _react2.default.createElement(
            _genericRowItem2.default,
            null,
            this.state.active && _react2.default.createElement(_backdrop2.default, { onClick: this.handleClickBackdrop }),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: filterClasses, onClick: this.toggleMenu },
                    _react2.default.createElement(
                        'div',
                        { className: _filter4.default.placeholder },
                        filterValue
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: contextMenuClasses, role: 'menu' },
                    _react2.default.createElement(
                        'ul',
                        { className: _filter4.default.stack },
                        filterItems.map(function (filter) {
                            return _react2.default.createElement(
                                'li',
                                { key: filter, className: _filter4.default.stackItem },
                                _react2.default.createElement(
                                    'a',
                                    {
                                        className: _filter4.default.option,
                                        onClick: function onClick() {
                                            _this2.handleClickBackdrop();
                                            setFilterValue(filter);
                                        }
                                    },
                                    filter
                                )
                            );
                        })
                    )
                )
            )
        );
    };

    return SearchFilter;
}(_react2.default.PureComponent);

exports.default = SearchFilter;


SearchFilter.propTypes = propTypes;